import { FundValueProgressionBarKey } from './constants';

const BAR_ORDER = Object.values(FundValueProgressionBarKey);

type BarValues = Record<FundValueProgressionBarKey, number>;

const getGroupedBarLayout = ({
  columnLeft,
  columnWidth,
  barWidth,
  barGap,
  values,
}: {
  columnLeft: number;
  columnWidth: number;
  barWidth: number;
  barGap: number;
  values: BarValues;
}) => {
  const layout: Array<{
    key: FundValueProgressionBarKey;
    x: number;
    width: number;
    value: number;
  }> = [];

  const visibleBars = BAR_ORDER.filter((key) => values[key] !== 0);

  if (visibleBars.length === 0) {
    return layout;
  }

  const groupWidth =
    visibleBars.length * barWidth + (visibleBars.length - 1) * barGap;
  const columnCenter = columnLeft + columnWidth / 2;
  const groupLeft = columnCenter - groupWidth / 2;

  visibleBars.forEach((key, index) => {
    layout.push({
      key,
      x: groupLeft + index * (barWidth + barGap),
      width: barWidth,
      value: values[key],
    });
  });

  return layout;
};

export default getGroupedBarLayout;
